"use client";

import { ISeriesApi, SeriesType } from "lightweight-charts";
import React, { useEffect, useRef, useState } from "react";
import { useChart } from "./context";

export interface LastPointMarkerProps {
    series: ISeriesApi<SeriesType> | null;
    data: any; // 最新的数据点
    color?: string;
}

/**
 * 在数据末端显示一个脉冲原点
 */
export const LastPointMarker: React.FC<LastPointMarkerProps> = ( { series, data, color = "#FF3D4C" } ) => {
    const { chart, container } = useChart();

    const [ pos, setPos ] = useState<{ x: number; y: number } | null>( null );

    const requestRef = useRef<number>( null );

    const updatePosition = () => {
        if ( !chart || !series || !data || !container ) {
            setPos( null );
            return;
        }

        const x = chart.timeScale().timeToCoordinate( data.time );
        const y = series.priceToCoordinate( data.value );

        if ( x !== null && y !== null ) {
            const timeScaleWidth = chart.timeScale().width();
            const chartHeight = container.clientHeight;

            // 检查是否在图表绘制区域内（不包括Y轴）
            if ( x >= 0 && x <= timeScaleWidth && y >= 0 && y <= chartHeight ) {
                setPos( { x, y } );
            } else {
                setPos( null );
            }
        } else {
            setPos( null );
        }

        requestRef.current = requestAnimationFrame( updatePosition );
    };

    useEffect( () => {
        updatePosition(); // 立即执行一次并开始循环

        return () => {
            if ( requestRef.current ) cancelAnimationFrame( requestRef.current );
        };
    }, [ chart, series, data, container ] );

    if ( !pos ) return null;

    return (
        <div
            className="absolute pointer-events-none z-20"
            style={{
                left: pos.x,
                top: pos.y,
                transform: "translate(-50%, -50%)",
            }}
        >
            {/* 核心原点 */}
            <div className="size-[0.5em] rounded-full relative" style={{ backgroundColor: color }}>
                {/* 扩散动画层 1 */}
                <div
                    className="absolute inset-0 rounded-full animate-ping opacity-80"
                    style={{ backgroundColor: color }}
                />
                {/* 扩散动画层 2 (可选，增加多层效果) */}
                {
                    /* <div
                    className="absolute inset-0 rounded-full animate-pulse opacity-50 scale-[2.5]"
                    style={{ backgroundColor: color }}
                /> */
                }
            </div>
        </div>
    );
};
